export const CONSTANTS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  USERS: 'users',
  COMPANY: 'company',
  FULL_ACCESS: 'Full Access',
  NO_ACCESS: 'No Access',
};

export const ACTIONS = {
  CREATE: 'create',
  READ: 'read',
  UPDATE: 'update',
  DELETE: 'delete',
};

export const EMAIL_FOR_TYPE = {
  SET_PASSWORD: 'setPassword',
  RESET_PASSWORD: 'resetPassword',
};

export const SOCKET_EVENTS = {
  CALL_START: 'call:start',
  CALL_END: 'call:end',
};

export const TemplateName = {
  EmailVerification: 'set-password',
  AccountActivated: 'account-activated',
  PartnerNetworkAccepted: 'partner-network-accepted',
  LeadToCustomer: 'lead-to-customer',
  LeadAssigned: 'leads-assigned',
  LeadReassigned: 'lead-reassigned',
  CampaignStatus: 'campaign-status',
  TasksAssigned: 'tasks-assigned',
  PartnerNetworkRequest: 'partner-network-requested',
  SupportRequest: 'support-request',
  SupportResponse: 'support-request-response',
  ResetPassword: 'password-reset-successfully',
  ForgotPassword: 'forgot-password',
  ResettingPassword: 'reset-password',
  PaymentDueReminder: 'payment-due-reminder',
  MyOperatorRequestAdmin: 'myoperator-request-admin',
};
